import { render, staticRenderFns } from "./indexTitle.vue?vue&type=template&id=65a52206"
import script from "./indexTitle.vue?vue&type=script&lang=js"
export * from "./indexTitle.vue?vue&type=script&lang=js"
import style0 from "./indexTitle.vue?vue&type=style&index=0&id=65a52206&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports